import { useEffect, useRef, useState } from 'preact/hooks'

export function useScrollHide(threshold = 10) {
  const [hidden, setHidden] = useState(false)
  const lastScrollY = useRef(0)

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY
      const atBottom = window.innerHeight + y >= document.documentElement.scrollHeight - 130

      if (atBottom) {
        setHidden(false)
      }
      else if (y > lastScrollY.current + threshold) {
        setHidden(true)
      }
      else if (y < lastScrollY.current - threshold) {
        setHidden(false)
      }

      lastScrollY.current = y
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [threshold])

  return hidden
}
